export enum IntegrationCardVariant {
  Column = 'column',
  Row = 'row',
}
